import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-smsType-lookup',
  templateUrl: './micro-smsType-lookup.component.html'
})
export class MicroSmsTypeLookupComponent  {

  @Input()
  smsTypeId:any;

  @Input()
  link:boolean = true;
}
